import React, {useState, useEffect} from "react";

const DesktopTabsForScheduledClasses= ({setActiveTab, activeTab, CoursePackage}) => {
    
    return (
        <div className="hidden lg:flex w-full h-[260px] justify-center items-center 
            bg-[linear-gradient(162deg,_#AEB0FF_0%,_#B05AC4_100%)]"
            // style={{ background: "linear-gradient(70deg, #170654 0%, #440F88 100%)" }}
            >
           <div className="w-[85%] h-fit flex flex-col gap-[70px] mt-[80px]">
                <p className="text-[42px] font-bold text-[#FFFFFF] "> {CoursePackage?.InstituteCourse?.Course?.CourseName} | {CoursePackage?.PackageName}</p>
                
                <div className="w-full flex gap-[90px] ml-[40px]">
                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                        onClick={() => setActiveTab("AboutClient")}>
                            About Learner
                        </p>
                        { activeTab === "AboutClient" && (
                            <div className="h-[7px] bg-[#FFFFFF]">
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                        onClick={() => setActiveTab("ScheduleAndInstructor")}>
                            Schedule and Instructor
                        </p>
                        { activeTab === "ScheduleAndInstructor" && (
                            <div className="h-[7px] bg-[#FFFFFF]">
                            </div>
                        )}
                    </div>
                </div>
           </div>
        </div>
    );
};

export default DesktopTabsForScheduledClasses;
